export default {
  name: 'Hint',
  props: ['text', 'imgs'],
  data() {
    return {
      dialog: false,
    };
  },
};
